import { lazy, Suspense } from "react"
import { ThemeProvider } from "@mui/material/styles"
import { BrowserRouter as Router, Route, Routes } from "react-router"

import theme from "./theme"
import Loading from "./components/loadingScreen"
import NavBar from "./components/NavBar"
import Wrapper from "./components/wrapper"
import Footer from "./components/Footer"

import ResourcesOutlet from "./routes/Resources/outlet"
import resourcesList from "./routes/Resources"
import PastSpeakers from "./routes/PastSpeakers/layout"

const Home = lazy(() => import("./routes/Home"))
const Contact = lazy(() => import("./routes/Contact"))
const SpeakerCards = lazy(() => import("./routes/PastSpeakers/cards"))
const NoMatch = lazy(() => import("./routes/NoMatch"))
const LinkRedirectPage = lazy(() => import("./routes/LinkRedirect"))

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Wrapper>
          <NavBar />
          <Routes>
            <Route path="resources" element={<ResourcesOutlet />}>
              {resourcesList}
            </Route>
            <Route path="past-speakers" element={<PastSpeakers />}>
              <Route
                index
                element={
                  <Suspense fallback={<Loading />}>
                    <SpeakerCards year="all" />
                  </Suspense>
                }
              />
              <Route
                path=":year"
                element={
                  <Suspense fallback={<Loading />}>
                    <SpeakerCards />
                  </Suspense>
                }
              />
            </Route>
            <Route
              path="contact"
              element={
                <Suspense fallback={<Loading />}>
                  <Contact />
                </Suspense>
              }
            />
            <Route
              index
              element={
                <Suspense fallback={<Loading />}>
                  <Home />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<Loading />}>
                  <NoMatch />
                </Suspense>
              }
            />
            <Route
              path="/link/:code"
              element={
                <Suspense fallback={<Loading />}>
                  <LinkRedirectPage />
                </Suspense>
              }
            />
          </Routes>
          <Footer />
        </Wrapper>
      </Router>
    </ThemeProvider>
  )
}
